import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../core/Icon';
import {
  StyledTooltipWrapper,
  StyledTooltipTopTxt,
  StyledTooltipBottomTxt,
  StyledTooltipChannelTxt,
  StyledTooltipFixedTxt,
  StyledTooltipShareTxt
} from './style';

const Tooltip = ({ active, payload = [] }) =>
  active && payload.length ? (
    <StyledTooltipWrapper>
      <StyledTooltipTopTxt>
        <Icon svg={payload[0].payload.colorLogo} width="30px" height="26px" />
        <StyledTooltipChannelTxt>
          {payload[0].payload.channel}
        </StyledTooltipChannelTxt>
      </StyledTooltipTopTxt>
      <StyledTooltipBottomTxt>
        <StyledTooltipFixedTxt>Share del día: </StyledTooltipFixedTxt>
        <StyledTooltipShareTxt>{`${payload[0].payload.share}%`}</StyledTooltipShareTxt>
      </StyledTooltipBottomTxt>
    </StyledTooltipWrapper>
  ) : null;

Tooltip.propTypes = {
  data: PropTypes.shape({
    channel: PropTypes.string,
    logo: PropTypes.any,
    share: PropTypes.number
  })
};

export default Tooltip;
